export default {"src":"/_next/static/media/deck.e45d1573.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};